module.exports = __webpack_public_path__ + "img/path-7.caa38aa1.svg";